import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import ReceiptModal from '../components/ReceiptModal';
import Spinner from 'react-bootstrap/Spinner';
import { db } from '../firebase';

const AuthenticationResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('pending');
  const [transaction, setTransaction] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const spiToken = params.get('spiToken') || params.get('SpiToken');
    if (!spiToken) {
      setStatus('denied');
      return;
    }

    const completePayment = async () => {
      try {
        const resp = await fetch(
          'https://us-central1-arzu-9380c.cloudfunctions.net/api/completePowerTranzPayment',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ spiToken })
          }
        );
        const data = await resp.json();

        // Validar criterios: aprobado, capturado y 3DS
        if (data.Approved && data.CaptureStatus === 'captured' && data.ThreeDSecure === true) {
          const now = new Date();
          const receiptData = {
            id: data.TransactionIdentifier,
            buyerName: data.CardholderName || '',
            date: now.getTime(),
            amount: data.TotalAmount,
            currency: data.CurrencyCode,
            authorizationCode: data.AuthorizationCode,
            captureStatus: data.CaptureStatus,
            threeDSecure: data.ThreeDSecure
          };

          // Guardar en Firestore
          await addDoc(collection(db, 'ordenes'), {
            ...receiptData,
            timestamp: Timestamp.fromDate(now)
          });

          setTransaction(receiptData);
          setStatus('approved');
        } else {
          setStatus('denied');
        }
      } catch (err) {
        console.error('Error al completar el pago:', err);
        setStatus('denied');
      }
    };

    completePayment();
  }, [location.search]);

  const handleClose = () => navigate('/');

  if (status === 'pending') {
    return <Spinner animation="border" className="m-5" />;
  }

  return (
    <ReceiptModal
      show={true}
      onHide={handleClose}
      transaction={transaction}
      status={status}
    />
  );
};

export default AuthenticationResult;
